import ProcessFlowStep from '~/models/processFlows/processFlowStep'
import {IInitialStep, IProcessFlowStepConstructorOptions} from "~/interfaces/processFlowInterfaces"
import {ProcessFlowStepType} from "../../enums/processFlowStepType";


export default class ProcessFlowInitialStep extends ProcessFlowStep implements IInitialStep {
  step_type: ProcessFlowStepType.InitialStep

  constructor(parent, options?: IProcessFlowStepConstructorOptions) {
    super(parent, options);
  }

  get defaultTitle(): string {
    return 'Start'
  }
}